"use strict";

module.exports = require("./actionCreators");


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/actionCreators/index.js
 ** module id = 506
 ** module chunks = 0
 **/